var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2Selected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 150,
    viewBox: "0 0 100 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2782",
    "data-name": "Group 2782",
    transform: "translate(-496 -610)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2139",
    "data-name": "Group 2139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1119",
    "data-name": "Rectangle 1119",
    transform: "translate(496 610)",
    fill: "#fff",
    stroke: "#7e6f68",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 150,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 149,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1125",
    "data-name": "Rectangle 1125",
    transform: "translate(506 621)",
    fill: "#fff",
    stroke: "#7e6f68",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1134",
    "data-name": "Rectangle 1134",
    transform: "translate(506 669)",
    fill: "#fff",
    stroke: "#7e6f68",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1135",
    "data-name": "Rectangle 1135",
    width: 38.936,
    height: 1,
    transform: "translate(551 640)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1153",
    "data-name": "Rectangle 1153",
    width: 38.936,
    height: 1,
    transform: "translate(551 688)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1148",
    "data-name": "Rectangle 1148",
    width: 38.936,
    height: 1,
    transform: "translate(551 623)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1155",
    "data-name": "Rectangle 1155",
    width: 38.936,
    height: 1,
    transform: "translate(551 671)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1136",
    "data-name": "Rectangle 1136",
    width: 38.936,
    height: 1,
    transform: "translate(551 652)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1151",
    "data-name": "Rectangle 1151",
    width: 38.936,
    height: 1,
    transform: "translate(551 700)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1138",
    "data-name": "Rectangle 1138",
    width: 38.936,
    height: 1,
    transform: "translate(551 646)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1152",
    "data-name": "Rectangle 1152",
    width: 38.936,
    height: 1,
    transform: "translate(551 694)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1149",
    "data-name": "Rectangle 1149",
    width: 38.936,
    height: 1,
    transform: "translate(551 629)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1154",
    "data-name": "Rectangle 1154",
    width: 38.936,
    height: 1,
    transform: "translate(551 677)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1139",
    "data-name": "Rectangle 1139",
    width: 38.936,
    height: 1,
    transform: "translate(551 658)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1150",
    "data-name": "Rectangle 1150",
    width: 38.936,
    height: 1,
    transform: "translate(551 706)",
    fill: "#7e6f68"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(537 745)",
    fill: "#7e6f68",
    fontSize: 24,
    fontFamily: "HelveticaNeue, Helvetica Neue",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Selected);
export default __webpack_public_path__ + "static/media/2-selected.9ddffcad.svg";
export { ForwardRef as ReactComponent };